// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../Config.bs.js";
import * as BlacklistPartnerRepo from "./BlacklistPartnerRepo.bs.js";
import * as DummyBlacklistPartnerRepo from "./DummyBlacklistPartnerRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyBlacklistPartnerRepo.BlacklistPartnerRepo;
  } else {
    return BlacklistPartnerRepo.BlacklistPartnerRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
